
/**
 * The Luhn algorithm.
 *
 * @param {string|number} str
 *
 * @return {number}
 */
function luhn (str) {
    let v   = 0;
    let sum = 0;

    str += '';

    for (let i = 0, l = str.length; i < l; i++) {
        v = str[i];
        v *= 2 - (i % 2);
        if (v > 9) {
            v -= 9;
        }
        sum += v;
    }

    return Math.ceil(sum / 10) * 10 - sum;
}


/**
 * Test date if lunh is true.
 *
 * @param {int} year
 * @param {int} month
 * @param {int} day
 *
 * @return {boolean}
 */
function testDate (year, month, day) {
    month -= 1;
    let date = new Date(year, month, day);
    return !(date.getYear() !== year || date.getMonth() !== month || date.getDate() !== day);
}


/**
 * Validate Swedish social security numbers.
 *
 * @param {string|number} str
 *
 * @return {boolean}
 */
const validate_swedish_ssn = function validate_swedish_ssn (str) {
    if (typeof str !== 'number' && typeof str !== 'string') {
        return false;
    }

    str += '';

    let reg     = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([\-|\+]{0,1})?(\d{3})(\d{0,1})$/;
    let match   = reg.exec(str);

    if (!match) {
        return false;
    }

    let century = match[1];
    let year    = match[2];
    let month   = match[3];
    let day     = match[4];
    let sep     = match[5];
    let num     = match[6];
    let check   = match[7];

    if (sep === undefined) {
        sep = '-';
    }

    if (year.length === 4) {
        year = year.substr(2);
    }

    let valid = luhn(year + month + day + num) === +check && !!check;

    if (valid && testDate(+year, +month, +day)) {
        return valid;
    }

    return valid && testDate(+year, +month, +day - 60);
};

export default validate_swedish_ssn;
